import { EncryptStorage } from "encrypt-storage";

let secretText: string = "TheQuckBrownFox213223232";
export const StorageService = new EncryptStorage(secretText, {
  prefix: "MEAndMe",
});
